var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hide)?_c('div',{class:['container', 'text-link-wrapper', ("" + _vm.page_style)]},[_c('p',{staticClass:"text-link",style:(_vm.linkStyle),on:{"click":_vm.goLink}},[_c('span',[_vm._v(_vm._s(_vm.formItem.title))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }